import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '../store/store';

const ChannelsRedirect: React.FC = () => {
  const store = useStore();

  if (!store.token) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/channels/@me" replace />;
};

export default ChannelsRedirect;
